// extracted by mini-css-extract-plugin
export default {"nhima-header":"NhimaReport_nhima-header__Ap76n","divider":"NhimaReport_divider__PBEKY"};